<script lang="ts" setup>
import ConfirmDialog, { type ConfirmDialogProps } from 'primevue/confirmdialog';
import BaseButton from './BaseButton.vue';
import BaseIcon from './BaseIcon.vue';
import { onClickOutside } from '@vueuse/core';
import { useConfirm } from 'primevue';
import { useTemplateRef } from 'vue';

const props = defineProps</* @vue-ignore */ ConfirmDialogProps>();

const elDialog = useTemplateRef('elDialog');
const { close } = useConfirm();
onClickOutside(elDialog, close);
</script>

<template>
  <ConfirmDialog v-bind="props">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        ref="elDialog"
        class="bg-white rounded-lg shadow-xl px-6 py-8 flex flex-col gap-5 w-100 md:w-140 max-w-[90vw]"
      >
        <div>
          <div class="flex justify-between w-full">
            <p class="font-semibold text-sand-800 text-base mb-1">{{ message.header }}</p>
            <BaseIcon
              name="close"
              size="sm"
              class="text-sand-500 cursor-pointer max-md:hidden"
              @click="rejectCallback"
            />
          </div>
          <p class="text-sand-500 text-sm">{{ message.message }}</p>
        </div>
        <div class="flex max-md:flex-col gap-2 self-end mt-6">
          <div>
            <BaseButton
              :label="message.rejectLabel"
              severity="secondary"
              variant="outlined"
              @click="rejectCallback"
            />
          </div>
          <div>
            <BaseButton :label="message.acceptLabel" severity="danger" @click="acceptCallback" />
          </div>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<style>
.p-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  border: none !important;
}
</style>
